<div class="profile">
    <ls-bonus-amount [isProfilePage]="isProfilePage">
        <button
            class="profile__btn"
            [hasIcon]="true"
            [name]="'common.button-profile' | translate"
            lsUiButtonKind="subtle"
            lsUiButtonPalette="neutral-1"
            lsUiButtonSize="small"
            (click)="navigate('/profile')"
        >
            <ls-ui-icon
                height="24"
                src="user"
                width="24"
            ></ls-ui-icon>
        </button>
    </ls-bonus-amount>
</div>
